import HeadTittle from "../../../../../components/HeadTittle";
import IncomingInvitationStatus from "./IncomingInvitationStatus";
import IncomingInvitationSearch from "./IncomingInvitationSearch";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const IncomingInvitationHeader = ({
                                      isOnline,
                                      setIsReload,
                                      item,
                                      handleChange,
                                      search,
                                      setSearch
}) => {
    return (
        <>
            <HeadTittle name={'visitor_incoming_invitation'}>
                <IncomingInvitationStatus isOnline={isOnline} setIsReload={setIsReload} item={item}/>
            </HeadTittle>
            <IncomingInvitationSearch
                item={item}
                handleChange={handleChange}
                search={search}
                setSearch={setSearch}
            />

        </>
    )
}

export default IncomingInvitationHeader
